// src/app/equipment-add/equipment-add.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Equipment } from '../objects/Equipment';
import { EquipmentService } from '../Services/equipment.services';
import { Manufacturer } from '../objects/Manufacturer';
import { ManufacturerService } from '../Services/manufacture.service';

@Component({
  selector: 'app-equipment-add',
  templateUrl: './equipment-add.component.html',
  styleUrls: ['./equipment-add.component.css'],
})
export class EquipmentAddComponent implements OnInit {

  newmanufature: Manufacturer = {
    id: 0,
    name: '',
    country: ''
  }

  newEquipment: Equipment = {
    id: 0,
    name: '',
    description: '',
    quantity: 0,
    manufacturer: this.newmanufature,
    imageUrl: '',
    dailyRate: 0,
  };

  manufacturers: Manufacturer[] = [];
  isSaving = false;
  imageError: string | null = null;

  constructor(
    private router: Router,
    private equipmentService: EquipmentService,
    private manufacturerService: ManufacturerService
  ) {}

  ngOnInit() {
    this.manufacturerService.getManufacturers().subscribe(list => this.manufacturers = list);
  }

  onManufacturerChange(manufacturerId: string) {
    const id = +manufacturerId;
    this.newEquipment.manufacturer = this.manufacturers.find(m => m.id === id) || this.newmanufature;
  }

  onImageSelected(event: Event) {
    this.imageError = null;
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      this.imageError = 'Please choose an image file.';
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      this.imageError = 'Image must be smaller than 2MB.';
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      this.newEquipment.imageUrl = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }

  removeImage() {
    this.newEquipment.imageUrl = '';
  }

  saveEquipment() {
    this.isSaving = true;
    this.newEquipment.dailyRate = +(this.newEquipment.dailyRate || 0);
    this.newEquipment.quantity = +(this.newEquipment.quantity || 0);
    this.equipmentService.addEquipment(this.newEquipment).subscribe({
      next: () => {
        this.isSaving = false;
        this.router.navigate(['/equipment']);
      },
      error: () => { this.isSaving = false; }
    });
  }

  cancel() {
    this.router.navigate(['/equipment']);
  }
}
